// extracted by mini-css-extract-plugin
export default {"wrapper":"baa-z"};